export interface Volume {
  code: string
  name: string
  count: string
  /** Spine color from the product mockup. */
  color: string
  intro: string
  highlights: string[]
  note?: string
  result: string
}

export const volumes: Volume[] = [
  {
    code: '1',
    name: 'Foundations & Ready-to-Run Practices',
    count: '12 practices',
    color: '#2563eb',
    intro: 'Build the essential actions every developing player needs.',
    highlights: [
      'Ready position',
      'Movement to the ball',
      'Basic footwork',
      'Forearm passing',
      'Platform control',
      'Target passing',
      'Overhead setting',
      'Setting body position',
      'Serving foundations',
      'Basic attack approach',
      'Communication',
      'Three-contact volleyball',
    ],
    note: 'Includes 12 READY 60™ practices.',
    result:
      'A clear technical foundation that connects movement, ball control, communication and simple rally play.',
  },
  {
    code: '2',
    name: 'Passing & Serve Receive',
    count: '12 practices',
    color: '#16a34a',
    intro: 'Develop stronger first contact and more control under pressure.',
    highlights: [
      'Platform angles',
      'Moving into the ball',
      'Passing from different directions',
      'Short and deep reception',
      'Reading the server',
      'Serve receive movement',
      'Passing to target',
      'Communication between receivers',
      'Common passing errors',
      'Serve-receive progressions',
    ],
    result:
      'Players learn to move earlier, control the first contact and create a more useful second ball.',
  },
  {
    code: '3',
    name: 'Setting & Attacking',
    count: '12 practices',
    color: '#ea580c',
    intro: 'Build the connection between the second and third contact.',
    highlights: [
      'Setting hand position',
      'Setter movement',
      'Body alignment',
      'Setting to targets',
      'Approach rhythm',
      'Attack timing',
      'Arm action',
      'High contact',
      'Controlled attacking',
      'Setter-hitter connection',
      'Attack progressions',
    ],
    result:
      'Players move from basic ball control toward organized attacking actions.',
  },
  {
    code: '4',
    name: 'Serving, Defense & Ball Control',
    count: '12 practices',
    color: '#dc2626',
    intro: 'Build consistency, defensive awareness and better control.',
    highlights: [
      'Serving mechanics',
      'Serving routines',
      'Target serving',
      'Defensive ready position',
      'Reading the hitter',
      'Digging',
      'Emergency contacts',
      'Court coverage',
      'Transition after defense',
      'Ball-control challenges',
      'Defensive communication',
    ],
    result:
      'Players become more reliable from the service line and more organized when defending.',
  },
  {
    code: '5',
    name: 'Team Play, Rotations & Game Situations',
    count: '12 practices',
    color: '#7c3aed',
    intro: 'Connect individual skills to real team volleyball.',
    highlights: [
      'Three-contact organization',
      'Support positioning',
      'Free-ball organization',
      'Serve-receive structure',
      'Basic rotation understanding',
      'Movement after serve',
      'Transition',
      'Small-sided games',
      'Decision-making',
      'Game situations',
      'Team communication',
    ],
    result:
      'Players begin to understand where to move, what to do next and how their role connects to the team.',
  },
  {
    code: '6',
    name: 'Practice Planning & Team Organization',
    count: '12 practices',
    color: '#334155',
    intro: 'Organize your gym, your players and your training week.',
    highlights: [
      '60-minute practices',
      '75-minute practices',
      '90-minute practices',
      'Small-group organization',
      'Large-group organization',
      'Limited-space practice',
      'Mixed-level groups',
      'Station training',
      'Weekly planning',
      'Match-week planning',
      'Player evaluation',
      'Season progression',
    ],
    result:
      'A repeatable structure that makes practice easier to plan and easier to run.',
  },
]
